import React from 'react';

import Icon, { type Size } from '@atlaskit/icon';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import ComponentTypesMetadata from '../../common/ui/component-types-metadata';
import { ComponentIconBackground } from './component-icon-background';

export const ComponentTypeIcon = (props: {
	type: keyof typeof ComponentTypesMetadata;
	testId?: string;
	size?: Size;
}) => {
	const { type, testId, size = 'medium' } = props;
	const { formatMessage } = useIntl();

	const componentType = ComponentTypesMetadata[type];

	return (
		<Tooltip content={formatMessage(componentType.name)}>
			<ComponentIconBackground testId={testId} type={type} size={size}>
				<Icon
					label={formatMessage(componentType.name)}
					primaryColor={token('color.icon.inverse', colors.N0)}
					glyph={componentType.icon}
				/>
			</ComponentIconBackground>
		</Tooltip>
	);
};
